import React from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // optional
type Props = {
    text: string;
};
export const Tooltip: React.FC<Props> = ({ text }: Props) => (
    <Tippy content={text}>
        <div>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.00309 12C9.28314 12 12 9.28314 12 5.99691C12 2.71686 9.27695 0 5.99691 0C2.71686 0 0 2.71686 0 5.99691C0 9.28314 2.72305 12 6.00309 12ZM5.95358 3.94843C5.52656 3.94843 5.17999 3.60186 5.17999 3.17483C5.17999 2.73543 5.52656 2.39505 5.95358 2.39505C6.3868 2.39505 6.72718 2.73543 6.72718 3.17483C6.72718 3.60186 6.3868 3.94843 5.95358 3.94843ZM4.96957 9.20887C4.72821 9.20887 4.53017 9.0294 4.53017 8.77566C4.53017 8.54048 4.72821 8.35482 4.96957 8.35482H5.68747V5.75554H5.07478C4.82723 5.75554 4.63538 5.57607 4.63538 5.32233C4.63538 5.08716 4.82723 4.9015 5.07478 4.9015H6.18257C6.48582 4.9015 6.65291 5.1181 6.65291 5.44611V8.35482H7.35224C7.59979 8.35482 7.79783 8.54048 7.79783 8.77566C7.79783 9.0294 7.59979 9.20887 7.35224 9.20887H4.96957Z"
                    fill="#C1C3CC"
                />
            </svg>
        </div>
    </Tippy>
);

export default Tooltip;
